export default "__VITE_ASSET__WAy_mZjl__"